import carAnnualReview from "./carAnnualReview/carAnnualReview.vue"
import driverAnnualReview from "./driverAnnualReview/driverAnnualReview.vue"

export default {
    name: 'AnnualReview',
    components: { carAnnualReview, driverAnnualReview },
    data() {
        return {
            id: '',
            activeName: 'first',
        }
    },
    created() {
        
    },
    methods: {
        handleClick(event) {
            console.log(event)
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$refs.TabCar.getCarAnnualList()
            } else {
                console.log(this.orgId)
                this.$nextTick(() => {
                    this.$refs.TabDriver.getDriverAnnualList()
                })

            }
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}